import React from "react";
import {
  bestselling1,
  bestselling2,
  bestselling3,
  bestselling4,
  bestselling5,
  bestselling6,
  dmcaImg,
  facebookIcon,
  footerBrandImgs,
  instagramIcon,
  paymentImg,
  twitterIcon,
  youtubeIcon,
} from "../../../asserts/images";
import { Link } from "react-router-dom";

const Footer = () => {
  const titles = [
    "PR Publication",
    "Book Publishing",
    "Printing Books",
    "Self-Help Publishing Amazon",
    "Amazon Printing",
    "Book Formatting",
    "Book Review Template",
    "Children's Book Editing",
    "Proofreading Editing",
  ];

  const ghostServices = [
    "business books",
    "Nonfiction",
    "memoir/autobiography",
    "fiction-writing",
    "Western Writing",
    "Romantic Writing",
    "Action Adventure",
    "Christian- Faith",
    "Drama Writing",
    "eBook Writing",
    "Horror Writing",
    "Hip Hop Ghostwriters",
    "Article Writing",
  ];

  const bookMarketings = [
    "Book Cover Design",
    "Audio Book",
    "Illustrations",
    "Author Logo Design",
    "Author E-Commerce Website",
    "Book Video",
    "Ebook Social Media Marketing",
    "EBook SEO",
  ];

  return (
    <>
      <section className="footer">
        <div className="footer_inner_div">
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-lg-9 col-sm-12">
                <div className="row">
                  <div className="col-md-12">
                    <div className="footer_social">
                      <div className="footer_social_item">
                        <Link>
                          <img
                            draggable={false}
                            src={instagramIcon}
                            className="footer_social_iconImg"
                            alt="instagramIcon"
                          />
                        </Link>

                        <div className="footer_social_text">
                          <p>
                            Followers <br />
                            <b>10K</b>
                          </p>
                        </div>
                      </div>
                      <div className="footer_social_item">
                        <Link>
                          <img
                            draggable={false}
                            src={facebookIcon}
                            className="footer_social_iconImg"
                            alt="facebookIcon"
                          />
                        </Link>

                        <div className="footer_social_text">
                          <p>
                            Followers <br />
                            <b>121K</b>
                          </p>
                        </div>
                      </div>
                      <div className="footer_social_item">
                        <Link>
                          <img
                            draggable={false}
                            src={youtubeIcon}
                            className="footer_social_iconImg"
                            alt="youtubeIcon"
                          />
                        </Link>

                        <div className="footer_social_text">
                          <p>
                            Followers <br />
                            <b>77K</b>
                          </p>
                        </div>
                      </div>
                      <div className="footer_social_item">
                        <Link>
                          <img
                            draggable={false}
                            src={twitterIcon}
                            className="footer_social_iconImg"
                            alt="twitterIcon"
                          />
                        </Link>

                        <div className="footer_social_text">
                          <p>
                            Followers <br />
                            <b>2K</b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="footer_spacer"></div>
                  <div className="col-sm-3">
                    <div className="footer_quick_links">
                      <h3 className="footer_subhead">
                        Ghostwriting
                      </h3>

                      <ul className="footer_links">
                        {/* <li className="footer_link">
                          <Link to={'javascript:;'}>business books</Link>
                        </li> */}
                        <li className="footer_link">
                          <Link to={'/non-fiction-writing'}>Nonfiction</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/memoir-writing'}>Memoir</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/autobiography-writing'}>Autobiography</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/fiction-writing'}>fiction</Link>
                        </li>
                        {/* <li className="footer_link">
                          <Link>Western Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link>Romantic Writing</Link>
                        </li> */}
                        <li className="footer_link">
                          <Link to={'/action-adventure-writing'}>Action Adventure Writing</Link>
                        </li>
                        {/* <li className="footer_link">
                          <Link to="faithfaith-writer">Christian- Faith</Link>
                        </li>
                        <li className="footer_link">
                          <Link>Drama Writing</Link>
                        </li> */}
                        <li className="footer_link">
                          <Link to={'/ebook-writing'}>eBook Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/novel-writing'}>Novel Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/horror-writing'}>Horror Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/hip-hop-writing'}>Hip Hop Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/article-writing-publication'}>Article Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/speech-writing'}>Speech Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/seo-content-writing'}>Seo Content Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/military-fiction-writing'}>Military Fiction Writing</Link>
                        </li>
                      </ul>

                      <ul className="footer_links">
                        {/* {
                            ghostServices.map((ghostservice, index) => (
                                <li key={index} className="footer_link">
                                <Link>{ghostservice}</Link>
                                </li>
                            ))
                        } */}
                      </ul>
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="footer_quick_links">
                      <h3 className="footer_subhead">
                        Books Editing
                      </h3>

                      <ul className="footer_links">
                        <li className="footer_link">
                          <Link to={'/book-formatting'}>Book Formatting</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/childrens-book-editors'}>Children's Book Editors</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/proof-reading'}>Book Proofreading</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/developmental-editing'}>developmental Editing</Link>
                        </li>
                        {/* <li className="footer_link">
                          <Link to={'javascript:;'}>Line Editing</Link>
                        </li> */}
                        <li className="footer_link">
                          <Link to={'/sensitive-reading'}>Sensitive Reading</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/comic-book-translation'}>Comic Book Translation</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/arabic-book-translation'}>Arabic Book Translation</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/french-book-translation'}>French Book Translation</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/spanish-book-translation'}>Spanish Book Translation</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/movie-writing'}>Movie Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/screen-writing'}>Screen Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/wiki-writing'}>Wiki Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/comic-writing'}>Comic Writing</Link>
                        </li>
                        {/* <li className="footer_link">
                          <Link to="/">Self-Help Publishing Amazon</Link>
                        </li>
                        <li className="footer_link">
                          <Link to="/">Amazon Printing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to="/">Book Formatting</Link>
                        </li>
                        <li className="footer_link">
                          <Link to="/">Book Review Template</Link>
                        </li>
                        <li className="footer_link">
                          <Link to="/children-illustration">
                            Children's Book Editing
                          </Link>
                        </li>
                        <li className="footer_link">
                          <Link to="/">Proofreading Editing</Link>
                        </li> */}
                      </ul>

                      {/* <ul className="footer_links">
                        {titles.map((title, index) => (
                            <li key={index} className="footer_link">
                            <Link>{title}</Link>
                            </li>
                        ))}
                        </ul> */}
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="footer_quick_links">
                      <h3 className="footer_subhead">
                        Illustrations
                      </h3>

                      <ul className="footer_links">
                        <li className="footer_link">
                          <Link to={'/book-illustration-services'}>Book Illustration Services</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/book-editing'}>Book Editing</Link> 
                        </li>
                        <li className="footer_link">
                          <Link to={'/comic-book-illustration'}>Comic Book Illustration</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/childrens-book-and-illustrations'}>Children's Book Illustration</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/children-book-printing'}>Children's Book Printing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/children-book-writing'}>Children's Book Writing</Link>
                        </li>
                        {/* <li className="footer_link">
                          <Link to="/">Author Logo Design</Link>
                        </li>
                        <li className="footer_link">
                          <Link to="/website-author">
                            Author E-Commerce Website
                          </Link>
                        </li>
                        <li className="footer_link">
                          <Link to="/">Book Video</Link>
                        </li>
                        <li className="footer_link">
                          <Link to="/">Ebook Social Media Marketing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to="/">EBook SEO</Link>
                        </li> */}
                      </ul>

                      {/* <ul className="footer_links">
                        {
                            bookMarketings.map((bookmarketing, index) => (
                                <li key={index} className="footer_link">
                                    <Link>{bookmarketing}</Link>
                                </li>
                            ))
                        }
                      </ul> */}
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="footer_quick_links">
                      <h3 className="footer_subhead">
                        Other Services
                      </h3>

                      <ul className="footer_links">
                        <li className="footer_link">
                          <Link to="/book-cover-design">Book Cover Design</Link>
                        </li>
                        <li className="footer_link">
                          <Link to="/audio-book-design">Audio Book</Link>
                        </li>
                        <li className="footer_link">
                          <Link to="/book-video-trailer">Book Trailer</Link>
                        </li>
                        {/* <li className="footer_link">
                          <Link to={'javascript:;'}>Author Logo Design</Link>
                        </li> */}
                        <li className="footer_link">
                          <Link to="/author-website">
                          Author Website Design
                          </Link>
                        </li>
                        <li className="footer_link">
                          <Link to="/book-publishing">Book Publishing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to="/book-marketing">Book Marketing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/book-writing-service'}>Book Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/story-writing'}>Story Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/song-writing'}>Song Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/narrative-writing'}>Narrative Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/rhyme-writing'}>Rhyme Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/script-writing'}>Script Writing</Link>
                        </li>
                        <li className="footer_link">
                          <Link to={'/comedy-writing'}>Comedy Writing</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-12">
                <div className="footer_avail">
                  {/* <h3 className="footer_avail-text">
                    Avail $199 Value <br />
                    Service For Free
                  </h3>
                  <button className="avail_btn">Avail Now</button> */}
                  <div className="dmca_img">
                    <img src={dmcaImg} alt="dmcaImg" />
                  </div>
                </div>
                <div className="footer_payment">
                  <h3 className="footer_payment-text">
                    <span class="color-red">Secure</span> payment By
                  </h3>
                  <div className="dmca_img">
                    <img src={paymentImg} alt="paymentImg" />
                  </div>
                </div>
                <div className="footer_extra_links">
                  <ul class="footer_links2">
                    <li class="footer_link">
                      <a href="tel:(855) 408-6509"><strong>Phone:</strong> (855) 408-6509</a>
                      </li>
                    <li class="footer_link">
                      <a href="mailto:info@falconbookwriting.com"><strong>Email:</strong> info@falconbookwriting.com</a>
                    </li>
                    <li class="footer_link">
                      <a href="javascript:;"><strong>Address:</strong> 18002 Java Isle Dr, Tampa, FL 33647, United States </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-12 col-lg-12">
                <div className="footer_extra_links">
                  <ul className="footer_links">
                    <li className="footer_link">
                      <Link to={'/about-us'}>About</Link>
                    </li>
                    <li className="footer_link">
                      <Link to={'/featured-author'}>Featured Author</Link>
                    </li>
                    <li className="footer_link">
                      <Link to={'/contact-us'}>Contact us</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="footer_spacer"></div>
              <div className="col-md-12">
                <div className="footer_brand_imgs">
                  <img src={bestselling1} className="img-fluid" alt="bestselling1" />
                  <img src={bestselling2} className="img-fluid" alt="bestselling2" />
                  <img src={bestselling3} className="img-fluid" alt="bestselling3" />
                  <img src={bestselling4} className="img-fluid" alt="bestselling4" />
                  <img src={bestselling5} className="img-fluid" alt="bestselling5" />
                  <img src={bestselling6} className="img-fluid" alt="bestselling6" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright_sec">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="copyright">
                  <p>© Copyright 
                     <span> {new Date().getFullYear()} </span>
                     Falcon Book Writing All Rights Reserved.</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="footer_termCondition_links">
                  <ul className="footer_links">
                    {/* <li className="footer_link">
                      <Link>Privacy Policy</Link>
                    </li> */}
                    <li className="footer_link">
                      <Link to={'/termsandconditions'}>Terms And Conditions</Link>
                    </li>
                    <li className="footer_link">
                       <Link to={'/privacy-policy'}>Privacy Policy</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
